import { AWS_AUTH_TYPES } from "../common/aws/AWSAuthenticationTypes";
export const toGenericS3InputCreateRequest = ({
  genericS3Name,
  awsAuthenticationType,
  awsAccessKey,
  awsSecretKey,
  contentTypes,
  awsS3Region,
  assumeRoleArn,
  genericS3ThrottleEnabled,
  pollingInterval,
  compressionType,
  sqsQueueName,
  key,
  secret,
  overrideSource,
  sqsMessageBatchSize
}) => ({
  name: genericS3Name.value,
  ...(awsAuthenticationType == null ? void 0 : awsAuthenticationType.value) === AWS_AUTH_TYPES.keysecret ? {
    aws_s3_access_key: awsAccessKey == null ? void 0 : awsAccessKey.value,
    aws_s3_secret: awsSecretKey == null ? void 0 : awsSecretKey.value
  } : {
    aws_s3_access_key: key,
    aws_s3_secret: secret
  },
  polling_interval: pollingInterval.value,
  polling_time_unit: "MINUTES",
  enable_throttling: !!(genericS3ThrottleEnabled == null ? void 0 : genericS3ThrottleEnabled.value),
  content_types: contentTypes.value,
  aws_s3_region: awsS3Region.value,
  assume_role_arn: assumeRoleArn == null ? void 0 : assumeRoleArn.value,
  compression_type: compressionType.value,
  sqs_queue_name: sqsQueueName.value,
  override_source: overrideSource.value,
  sqs_message_batch_size: sqsMessageBatchSize.value
});
export const toGenericInputCreateRequest = ({
  genericS3Name,
  awsAccessKey,
  awsSecretKey,
  contentTypes,
  awsS3Region,
  assumeRoleArn,
  genericS3ThrottleEnabled,
  pollingInterval,
  compressionType,
  sqsQueueName,
  awsAuthenticationType,
  key,
  secret,
  overrideSource,
  sqsMessageBatchSize
}) => ({
  type: "org.graylog.enterprise.integrations.generics3.GenericS3Input",
  title: genericS3Name.value,
  global: false,
  configuration: {
    ...(awsAuthenticationType == null ? void 0 : awsAuthenticationType.value) === AWS_AUTH_TYPES.keysecret ? {
      aws_s3_access_key: awsAccessKey == null ? void 0 : awsAccessKey.value,
      aws_s3_secret: awsSecretKey == null ? void 0 : awsSecretKey.value
    } : {
      aws_s3_access_key: key,
      aws_s3_secret: secret
    },
    polling_interval: pollingInterval.value,
    polling_time_unit: "MINUTES",
    throttling_allowed: !!(genericS3ThrottleEnabled == null ? void 0 : genericS3ThrottleEnabled.value),
    content_types: contentTypes.value,
    aws_s3_access_key: awsAccessKey.value,
    aws_s3_secret: awsSecretKey.value,
    aws_s3_region: awsS3Region.value,
    assume_role_arn: assumeRoleArn.value,
    compression_type: compressionType.value,
    sqs_queue_name: sqsQueueName.value,
    override_source: overrideSource.value,
    sqs_message_batch_size: sqsMessageBatchSize.value
  }
});
